module.exports = __webpack_public_path__ + "img/birthYear.0b5719eb.png";